
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33584',
  depVersions: {
  "documents-public-ui": "static-1.33584",
  "client-types": "static-1.437",
  "documents-lib": "static-1.33589",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1774",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5247",
  "hs-test-utils": "static-1.7642",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11076",
  "I18n": "static-7.1528",
  "jasmine-immutable": "static-1.2669",
  "jasmine-runner": "static-1.6111",
  "lodash": "static-1.3",
  "quartz": "static-1.6519",
  "react": "static-7.151",
  "react-dlb": "static-1.67",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16282",
  "reporting-data": "static-1.65903",
  "reporting-testing-lib": "static-1.7837",
  "reporting-visualizations": "static-1.57980",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4403",
  "webpack-env": "static-1.54",
  "atom": "static-1.4731",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2119",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90809",
  "cssUtils": "static-1.683",
  "customer-data-filters-ui": "static-1.38373",
  "customer-data-objects": "static-1.7266",
  "customer-data-property-utils": "static-1.7722",
  "data-fetching-client": "static-1.9332",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4193",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84863",
  "FormUrlGenerator": "static-2.4390",
  "foundations-components": "static-1.7210",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11384",
  "icons": "static-2.602",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6797",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3519",
  "property-translator": "static-1.5073",
  "quartz-config": "static-1.297",
  "quartz-core": "static-1.5738",
  "quick-fetch": "static-1.3595",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5046",
  "react-virtualized": "static-2.91",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7817",
  "reference-resolvers-lite": "static-1.7749",
  "report-customization-components": "static-1.12124",
  "reporting-enablement": "static-1.21599",
  "reporting-reports": "static-1.65582",
  "reporting-snowflake": "static-1.54522",
  "reporting-ui-components": "static-2.63176",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4260",
  "sales-content-partitioning": "static-1.8594",
  "SalesContentIndexUI": "static-3.8681",
  "sanitize": "static-1.4133",
  "sanitize-text": "static-1.7798",
  "self-service-api": "static-1.9881",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1445",
  "signup-constants": "static-1.18089",
  "signup-ui-lego-core": "static-1.20099",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4426",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10655",
  "ui-addon-i18n": "static-1.10784",
  "ui-addon-react-router-dom": "static-1.9199",
  "ui-addon-upgrades": "static-9.17350",
  "ui-asset-management-lib": "static-1.10499",
  "ui-images": "static-2.1043",
  "UIComponents": "static-3.8023",
  "usage-tracker": "static-1.6994",
  "usage-tracker-container": "static-1.6984",
  "usage-tracker-core": "static-1.6844",
  "usage-tracker-public": "static-1.6805",
  "viral-links-lib": "static-1.6673",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3094",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2796",
  "quartz-webpack": "static-1.2743",
  "ai-components-ui-library": "static-1.7983",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4486",
  "foundations-theming": "static-1.4058",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4680",
  "foundations-theming-base": "static-1.3043",
  "HeadJS": "static-2.679",
  "framer-motion": "static-1.62",
  "hs-test-utils-bend-plugin": "static-1.2753",
  "msw": "static-1.39",
  "testing-library": "static-1.144",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3990",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7582",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3326",
  "persist-promise": "static-1.3343",
  "reporting-client-types": "static-1.2334",
  "hs-story-utils": "static-1.9088",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9121",
  "hubspotter-http": "static-1.4345",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6909",
  "crm-message-bus": "static-1.41961",
  "customer-data-filters-ui-msw-helpers": "static-1.20807",
  "customer-data-objects-ui-components": "static-1.12656",
  "customer-data-reference-ui-components": "static-1.12783",
  "customer-data-ui-utilities": "static-1.9481",
  "framework-builder-read-service-client": "static-1.3714",
  "framework-data-schema-quick-fetch": "static-1.6427",
  "framework-data-schema-resolvers": "static-1.6522",
  "inbound-db-properties-service-client": "static-1.3547",
  "multi-account-reference-resolvers": "static-1.621",
  "onboarding-tours": "static-1.16067",
  "reporting-datasets-permissions-lib": "static-1.12593",
  "ui-addon-teams": "static-1.21025",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67168",
  "customer-data-properties": "static-1.50352",
  "forms-ai-lib": "static-1.3773",
  "forms-utils-lib": "static-1.11900",
  "foundations-components-test-utils": "static-1.4693",
  "react-dnd-compat": "static-1.4284",
  "react-tinymce": "static-1.54231",
  "tinymce-config": "static-2.53357",
  "ui-gdpr-components": "static-1.10004",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3479",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.58",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.902",
  "ui-fonts": "static-1.338",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.759",
  "mobile-manifest-mixins": "static-1.452",
  "quartz-auth": "static-1.194",
  "quartz-head": "static-1.184",
  "quartz-i18n": "static-1.194",
  "quartz-test": "static-1.194",
  "batch-promise": "static-1.1186",
  "external-options-client-types": "static-1.3849",
  "react-colorpicker": "static-2.9873",
  "reporting-insights-lib": "static-1.758",
  "copilot-toolkit": "static-1.10175",
  "data-quality-ui-library": "static-1.12001",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40329",
  "reporting-plugins": "static-1.9784",
  "ui-addon-draggable-compat": "static-2.3913",
  "ui-addon-opt": "static-4.8047",
  "ui-shepherd-react": "static-3.9800",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24323",
  "hubspot-apollo-client": "static-1.4535",
  "sales-templates-service-types-lib": "static-1.3861",
  "ui-business-units-lib": "static-1.8665",
  "growth-monetization-service-types": "static-1.4193",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4186",
  "purchase-motions-components": "static-1.5262",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3772",
  "upgrade-management-service-types": "static-1.4177",
  "timezone-utils": "static-2.4905",
  "bender-build-tools": "static-1.2770",
  "chatspot-core": "static-1.19775",
  "bend-plugin-foundations-theming": "static-1.2541",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3489",
  "crm-pipelines-api-client-types": "static-1.3833",
  "multi-currency-client-types": "static-1.3389",
  "getting-started-shared-tasks": "static-1.17449",
  "growth-data-modal": "static-1.4986",
  "growth-onboarding-confetti": "static-1.2710",
  "growth-onboarding-next-action-utils": "static-1.1144",
  "navigation-components": "static-1.16869",
  "onboarding-tours-client": "static-1.4281",
  "onboarding-tours-utils": "static-1.133",
  "ui-shepherd-tracker": "static-1.7181",
  "ui-universal-auth": "static-1.8489",
  "user-context": "static-1.4745",
  "cms-field-types": "static-1.4461",
  "content-icons-ui": "static-1.2098",
  "calling-global-api": "static-1.63175",
  "calling-internal-common": "static-1.30944",
  "calling-lifecycle-internal": "static-1.64557",
  "calling-lifecycle-messages": "static-1.56851",
  "commerce-products-lib": "static-1.8411",
  "crm-links": "static-1.5902",
  "file-manager-components": "static-1.22481",
  "google-libphonenumber": "static-1.31",
  "inbounddb-objects-service-types": "static-1.3917",
  "meetings-icalendar-utils-lib": "static-1.292",
  "object-builder-ui-client": "static-1.47495",
  "pipeline-validation-client-types": "static-1.3652",
  "property-value-citations": "static-1.966",
  "smart-property-lib": "static-1.5356",
  "tiered-pricing": "static-1.604",
  "ui-addon-iframeable": "static-1.8663",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19228",
  "tinymce-themes": "static-1.55327",
  "data-token-picker": "static-1.15818",
  "hub-http-contrib": "static-1.2705",
  "interframe": "static-3.4447",
  "tinymce-data": "static-1.39442",
  "tinymce-plugins": "static-1.56471",
  "ui-addon-sales-email": "static-1.4874",
  "hubspotter-http-shared-msw-handlers": "static-1.9119",
  "magpie-lib": "static-1.5231",
  "magpie-types": "static-1.4691",
  "simple-logging-lib": "static-1.2709",
  "content-assistance-lib": "static-1.7244",
  "dashboard-lib": "static-1.80071",
  "ExportDialog": "static-6.10044",
  "hubspot-prosemirror": "static-1.17228",
  "hubspot-prosemirror-plugins": "static-1.17220",
  "integrations-lib": "static-1.14962",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8346",
  "campaign-roi-lib": "static-1.7869",
  "feedback-loader": "static-1.28612",
  "commerce-analytics-service-client": "static-1.3344",
  "onboarding-scopes": "static-1.6100",
  "apollo-link-hub-http": "static-2.4307",
  "nav-client-types": "static-1.1990",
  "purchase-motions-api": "static-1.5265",
  "trials-service-types": "static-1.3594",
  "chatspot-client-types": "static-1.10296",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.384",
  "getting-started-shared-tasks-store": "static-1.16567",
  "calling-error-reporting": "static-1.30950",
  "shared-worker-versioning": "static-1.10675",
  "calling-usage-tracker": "static-1.6197",
  "calling-orchestration-shared-library": "static-1.34361",
  "customer-data-tracking": "static-1.6519",
  "products-iframe-lib": "static-1.6978",
  "products-ui-components-shared-msw-handlers": "static-1.9503",
  "location-customization-utils-lib": "static-1.8109",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3813",
  "video-components-external": "static-1.10133",
  "video-data-lib": "static-1.33791",
  "breeze-intelligence-kit": "static-1.5116",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9204",
  "fsm": "static-1.3388",
  "policy-lib": "static-1.6460",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9267",
  "navigation-messaging": "static-1.6196",
  "FileManagerLib": "static-1.38121",
  "NamespacedHubStyle": "static-2.8769",
  "FileManagerCore": "static-1.37980",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11787",
  "layout-dnd-utils": "static-1.10762",
  "react-codemirror": "static-1.10260",
  "ui-addon-emoji-picker": "static-1.9550",
  "ui-brand-identity-lib": "static-1.13305",
  "ui-addon-video-player": "static-1.8379",
  "ui-coaching-tips": "static-1.27550",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8258",
  "payment-link-components": "static-1.22549",
  "EmailSignatureEditor": "static-1.23669",
  "integrations-error-boundary-lib": "static-1.12377",
  "integrations-tracking-lib": "static-1.5240",
  "native-integrations-shared-strings": "static-1.7442",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10032",
  "rxjs": "static-5.10",
  "eligibility-engine-service-types": "static-1.2875",
  "calling-orchestration-schema": "static-1.34586",
  "sales-views-client-types": "static-1.3949",
  "crm-record-cards-service-types": "static-1.3326",
  "content-media-composition-data-lib": "static-1.10851",
  "content-media-compositions": "static-2.14858",
  "media-bridge-lib": "static-1.18344",
  "trellis-story-utils": "static-1.4183",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5412",
  "FileManagerImages": "static-1.35632",
  "video-components": "static-1.12136",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4183",
  "video-embed": "static-1.34625",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67243",
  "layout-data-lib": "static-1.9087",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6245",
  "commerce-tours-lib": "static-1.5499",
  "growth-onboarding-reliability": "static-1.4748",
  "sales-checkout-service-client": "static-1.3356",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21068",
  "sales-email-signature-service-client": "static-1.3497",
  "universal-page-editor-lib": "static-1.2653",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21016",
  "outpost": "static-1.3875",
  "advanced-menus-core": "static-1.14596",
  "advanced-menus-lib": "static-1.11597",
  "ui-memberships-settings-lib": "static-1.33040",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14595",
  "simple-menus-lib": "static-1.16112"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33584",
  "client-types": "/client-types/static-1.437",
  "documents-lib": "/documents-lib/static-1.33589",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1774",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5247",
  "hs-test-utils": "/hs-test-utils/static-1.7642",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11076",
  "I18n": "/I18n/static-7.1528",
  "jasmine-immutable": "/jasmine-immutable/static-1.2669",
  "jasmine-runner": "/jasmine-runner/static-1.6111",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6519",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.67",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16282",
  "reporting-data": "/reporting-data/static-1.65903",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7837",
  "reporting-visualizations": "/reporting-visualizations/static-1.57980",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4403",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4731",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2119",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90809",
  "cssUtils": "/cssUtils/static-1.683",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38373",
  "customer-data-objects": "/customer-data-objects/static-1.7266",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7722",
  "data-fetching-client": "/data-fetching-client/static-1.9332",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4193",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84863",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4390",
  "foundations-components": "/foundations-components/static-1.7210",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11384",
  "icons": "/icons/static-2.602",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6797",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3519",
  "property-translator": "/property-translator/static-1.5073",
  "quartz-config": "/quartz-config/static-1.297",
  "quartz-core": "/quartz-core/static-1.5738",
  "quick-fetch": "/quick-fetch/static-1.3595",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5046",
  "react-virtualized": "/react-virtualized/static-2.91",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7817",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7749",
  "report-customization-components": "/report-customization-components/static-1.12124",
  "reporting-enablement": "/reporting-enablement/static-1.21599",
  "reporting-reports": "/reporting-reports/static-1.65582",
  "reporting-snowflake": "/reporting-snowflake/static-1.54522",
  "reporting-ui-components": "/reporting-ui-components/static-2.63176",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4260",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8594",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8681",
  "sanitize": "/sanitize/static-1.4133",
  "sanitize-text": "/sanitize-text/static-1.7798",
  "self-service-api": "/self-service-api/static-1.9881",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1445",
  "signup-constants": "/signup-constants/static-1.18089",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20099",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4426",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10655",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10784",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9199",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17350",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10499",
  "ui-images": "/ui-images/static-2.1043",
  "UIComponents": "/UIComponents/static-3.8023",
  "usage-tracker": "/usage-tracker/static-1.6994",
  "usage-tracker-container": "/usage-tracker-container/static-1.6984",
  "usage-tracker-core": "/usage-tracker-core/static-1.6844",
  "usage-tracker-public": "/usage-tracker-public/static-1.6805",
  "viral-links-lib": "/viral-links-lib/static-1.6673",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3094",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2796",
  "quartz-webpack": "/quartz-webpack/static-1.2743",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7983",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4486",
  "foundations-theming": "/foundations-theming/static-1.4058",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4680",
  "foundations-theming-base": "/foundations-theming-base/static-1.3043",
  "HeadJS": "/HeadJS/static-2.679",
  "framer-motion": "/framer-motion/static-1.62",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2753",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.144",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3990",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7582",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3326",
  "persist-promise": "/persist-promise/static-1.3343",
  "reporting-client-types": "/reporting-client-types/static-1.2334",
  "hs-story-utils": "/hs-story-utils/static-1.9088",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9121",
  "hubspotter-http": "/hubspotter-http/static-1.4345",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6909",
  "crm-message-bus": "/crm-message-bus/static-1.41961",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20807",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12656",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12783",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9481",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3714",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6427",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6522",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3547",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.621",
  "onboarding-tours": "/onboarding-tours/static-1.16067",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12593",
  "ui-addon-teams": "/ui-addon-teams/static-1.21025",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67168",
  "customer-data-properties": "/customer-data-properties/static-1.50352",
  "forms-ai-lib": "/forms-ai-lib/static-1.3773",
  "forms-utils-lib": "/forms-utils-lib/static-1.11900",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4693",
  "react-dnd-compat": "/react-dnd-compat/static-1.4284",
  "react-tinymce": "/react-tinymce/static-1.54231",
  "tinymce-config": "/tinymce-config/static-2.53357",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10004",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3479",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.58",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.902",
  "ui-fonts": "/ui-fonts/static-1.338",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.759",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.452",
  "quartz-auth": "/quartz-auth/static-1.194",
  "quartz-head": "/quartz-head/static-1.184",
  "quartz-i18n": "/quartz-i18n/static-1.194",
  "quartz-test": "/quartz-test/static-1.194",
  "batch-promise": "/batch-promise/static-1.1186",
  "external-options-client-types": "/external-options-client-types/static-1.3849",
  "react-colorpicker": "/react-colorpicker/static-2.9873",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.758",
  "copilot-toolkit": "/copilot-toolkit/static-1.10175",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12001",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40329",
  "reporting-plugins": "/reporting-plugins/static-1.9784",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3913",
  "ui-addon-opt": "/ui-addon-opt/static-4.8047",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9800",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24323",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4535",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3861",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8665",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4193",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4186",
  "purchase-motions-components": "/purchase-motions-components/static-1.5262",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3772",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4177",
  "timezone-utils": "/timezone-utils/static-2.4905",
  "bender-build-tools": "/bender-build-tools/static-1.2770",
  "chatspot-core": "/chatspot-core/static-1.19775",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2541",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3489",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3833",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3389",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17449",
  "growth-data-modal": "/growth-data-modal/static-1.4986",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2710",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1144",
  "navigation-components": "/navigation-components/static-1.16869",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4281",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.133",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7181",
  "ui-universal-auth": "/ui-universal-auth/static-1.8489",
  "user-context": "/user-context/static-1.4745",
  "cms-field-types": "/cms-field-types/static-1.4461",
  "content-icons-ui": "/content-icons-ui/static-1.2098",
  "calling-global-api": "/calling-global-api/static-1.63175",
  "calling-internal-common": "/calling-internal-common/static-1.30944",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64557",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56851",
  "commerce-products-lib": "/commerce-products-lib/static-1.8411",
  "crm-links": "/crm-links/static-1.5902",
  "file-manager-components": "/file-manager-components/static-1.22481",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3917",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.292",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47495",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3652",
  "property-value-citations": "/property-value-citations/static-1.966",
  "smart-property-lib": "/smart-property-lib/static-1.5356",
  "tiered-pricing": "/tiered-pricing/static-1.604",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8663",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19228",
  "tinymce-themes": "/tinymce-themes/static-1.55327",
  "data-token-picker": "/data-token-picker/static-1.15818",
  "hub-http-contrib": "/hub-http-contrib/static-1.2705",
  "interframe": "/interframe/static-3.4447",
  "tinymce-data": "/tinymce-data/static-1.39442",
  "tinymce-plugins": "/tinymce-plugins/static-1.56471",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4874",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9119",
  "magpie-lib": "/magpie-lib/static-1.5231",
  "magpie-types": "/magpie-types/static-1.4691",
  "simple-logging-lib": "/simple-logging-lib/static-1.2709",
  "content-assistance-lib": "/content-assistance-lib/static-1.7244",
  "dashboard-lib": "/dashboard-lib/static-1.80071",
  "ExportDialog": "/ExportDialog/static-6.10044",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17228",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17220",
  "integrations-lib": "/integrations-lib/static-1.14962",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8346",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7869",
  "feedback-loader": "/feedback-loader/static-1.28612",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3344",
  "onboarding-scopes": "/onboarding-scopes/static-1.6100",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4307",
  "nav-client-types": "/nav-client-types/static-1.1990",
  "purchase-motions-api": "/purchase-motions-api/static-1.5265",
  "trials-service-types": "/trials-service-types/static-1.3594",
  "chatspot-client-types": "/chatspot-client-types/static-1.10296",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.384",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16567",
  "calling-error-reporting": "/calling-error-reporting/static-1.30950",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10675",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6197",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34361",
  "customer-data-tracking": "/customer-data-tracking/static-1.6519",
  "products-iframe-lib": "/products-iframe-lib/static-1.6978",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9503",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8109",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3813",
  "video-components-external": "/video-components-external/static-1.10133",
  "video-data-lib": "/video-data-lib/static-1.33791",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5116",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9204",
  "fsm": "/fsm/static-1.3388",
  "policy-lib": "/policy-lib/static-1.6460",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9267",
  "navigation-messaging": "/navigation-messaging/static-1.6196",
  "FileManagerLib": "/FileManagerLib/static-1.38121",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8769",
  "FileManagerCore": "/FileManagerCore/static-1.37980",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11787",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10762",
  "react-codemirror": "/react-codemirror/static-1.10260",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9550",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13305",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8379",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27550",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8258",
  "payment-link-components": "/payment-link-components/static-1.22549",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23669",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12377",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5240",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7442",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10032",
  "rxjs": "/rxjs/static-5.10",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2875",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34586",
  "sales-views-client-types": "/sales-views-client-types/static-1.3949",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3326",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10851",
  "content-media-compositions": "/content-media-compositions/static-2.14858",
  "media-bridge-lib": "/media-bridge-lib/static-1.18344",
  "trellis-story-utils": "/trellis-story-utils/static-1.4183",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5412",
  "FileManagerImages": "/FileManagerImages/static-1.35632",
  "video-components": "/video-components/static-1.12136",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4183",
  "video-embed": "/video-embed/static-1.34625",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67243",
  "layout-data-lib": "/layout-data-lib/static-1.9087",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6245",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5499",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4748",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3356",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21068",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3497",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2653",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21016",
  "outpost": "/outpost/static-1.3875",
  "advanced-menus-core": "/advanced-menus-core/static-1.14596",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11597",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33040",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14595",
  "simple-menus-lib": "/simple-menus-lib/static-1.16112"
}
};
